module.exports = __webpack_public_path__ + "img/mp3.88d3215c.svg";